import { render, staticRenderFns } from "./CharacterStatisticsBlock.vue?vue&type=template&id=35f5d2f3&scoped=true&"
import script from "./CharacterStatisticsBlock.vue?vue&type=script&lang=ts&"
export * from "./CharacterStatisticsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterStatisticsBlock.vue?vue&type=style&index=0&id=35f5d2f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5d2f3",
  null
  
)

export default component.exports